// removed by extract-text-webpack-plugin
module.exports = {"title":"BuyerAssuranceTooltip-style__title__1Nb29","body":"BuyerAssuranceTooltip-style__body__2z7Qm","hr":"BuyerAssuranceTooltip-style__hr__3hAPi","wrapper":"BuyerAssuranceTooltip-style__wrapper__2tcNm","content":"BuyerAssuranceTooltip-style__content__22_Tf","triangle":"BuyerAssuranceTooltip-style__triangle__3VIAL"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/BuyerAssurance/BuyerAssuranceTooltip-style.scss
// module id = 1692
// module chunks = 4 7